export default {
    manage_createEditAsset_label: "Etiqueta",
    manage_createEditAsset_assetType: "Tipo",
    manage_createEditAsset_assetSubtype: "Subtipo",
    manage_createEditAsset_licensePlate: "Matrícula",
    manage_createEditAsset_registrationCountry: "País del Registro",
    manage_createEditAsset_registrationState: "Estado del Registro",
    manage_createEditAsset_registrationExpiration: "Fecha de expiración del Registro",
    manage_createEditAsset_vin: "VIN",
    manage_createEditAsset_make: "Marca",
    manage_createEditAsset_model: "Modelo",
    manage_createEditAsset_year: "Año",
    manage_createEditAsset_engineLiters: "Litros del Motor",
    manage_createEditAsset_highway: "Autopista",
    manage_createEditAsset_city: "Ciudad",
    manage_createEditAsset_inspectionTagId: "ID de Etiqueta de Inspección",
    manage_createEditAsset_asset: "Activo",
    manage_createEditAsset_tags: "Etiquetas",
    manage_createEditAsset_powerUnitNumber: "Número de unidad de potencia",
    manage_createEditAsset_decodeVIN: "Decodificar VIN",
    manage_createEditAsset_inspectionDeviceType: "Tipo de Dispositivo de Inspección",
    manage_createEditAsset_noInformationFoundVIN: "No se ha encontrado información para este VIN",
    manage_createEditAsset_maxValue: "Valor máx",
    manage_createEditAsset_minValue: "Valor mín",
    manage_createEditAsset_externalId: "ID Externo",
    manage_createEditAsset_createAsset: "Crear Nuevo Activo",
    manage_createEditAsset_assetSaved: "Activo Guardado",
    manage_createEditAsset_duplicatedLabel: "La etiqueta ya está en uso",
    manage_createEditAsset_duplicatedlicensePlace: "La matrícula ya está en uso",
    manage_createEditAsset_duplicatedVin: "El VIN ya está en uso",
    manage_createEditAsset_errorVin: "VIN inválido, debe tener 17 caracteres alfanuméricos, sin I, O o Q, sin caracteres especiales ni espacios, y con un dígito de control válido en la novena posición",
    manage_createEditAsset_duplicatedexternalId: "El identificador externo ya está en uso",
    manage_createEditAsset_placeholderLabel: "Introduzca el nombre o el código del activo",
    manage_createEditAsset_status: "Estado",
    manage_createEditAsset_active: "Activo",
    manage_createEditAsset_inactive: "Inactivo",
    manage_createEditAsset_successMessageCreate: "El activo se ha creado correctamente",
    manage_createEditAsset_successMessageUpdate: "El activo se ha actualizado correctamente",
    manage_createEditAsset_duplicatedTagId: "El ID de la etiqueta de inspección ya está en uso",
    manage_createEditAsset_enterExternalId: "Introducir ID Externo",
    manage_createEditAsset_licenseCountry: "País de la Licencia",
    manage_createEditAsset_licenseState: "Estado de la licencia",
    manage_createEditAsset_none: "Ninguno",
    manage_createEditAsset_requiredFields: "Todos los campos obligatorios deben estar rellenados y contener valores válidos para continuar",
    manage_createEditAsset_alert_title: "Error de validación",
    manage_createEditAsset_licensePlateErrorLength: "La matrícula debe tener entre 4 y 20 caracteres",
}
